import { Grid, Link as MuiLink } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledGrid = styled(Grid, { shouldForwardProp: (prop) => prop !== '$active' })<{
  $active?: boolean;
}>`
  padding: ${(props) => props.theme.typography.pxToRem(16)}
    ${(props) => props.theme.typography.pxToRem(20)}
    ${(props) => props.theme.typography.pxToRem(16)}
    ${(props) => props.theme.typography.pxToRem(20)};
  background-color: ${(props) =>
    props.$active ? props.theme.palette.custom.brandpink : 'transparent'};

  &:hover {
    background-color: ${(props) => props.theme.palette.custom.brandpink};
  }
`

export const StyledTab = styled(MuiLink)`
  color: ${(props) => props.theme.palette.text.primary};
  text-decoration: none;
  aria-haspopup="menu";
`
